import React from 'react';
import useStyles from './styles';
import clsx from 'clsx';
import Avatar from '@material-ui/core/Avatar';
import Tooltip from '@material-ui/core/Tooltip';

const LevelMeter = (props) => {

    const { lvlPercent = 20, lvlText = 'Stage 1', feedCount = 0, iconUrl = './assets/images/components/island/particle/hssIcon.png' } = props;
    const classes = useStyles(props)

    return (
        <div className={classes.root}>
            <Avatar className={clsx(classes.avatar, classes.gray, classes.borderColor_orange)} src={iconUrl}></Avatar>
            <div className={classes.progressbar_container}>
                <div className={classes.moodText}>{lvlText}</div>
                <div className={clsx(classes.progressbar, classes.gray, classes.borderColor_orange)}>
                    <span style={{ width: `${lvlPercent}%` }} className={clsx(classes.progress, classes.orange)}></span>
                    <Tooltip title="Feed count for next stage"><span className={clsx(classes.feedCount)}>{feedCount}/15</span></Tooltip>
                </div>
            </div>
        </div >
    )
}

export default LevelMeter;